import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { EditProfile, Users } from "../../../Constant";
import MyProfile from "./MyProfile/MyProfile";
import EditProfileForm from "./EditProfiles/EditProfileForm";
import AddProjectsAndUpload from "./AddProjectsAndUpload/AddProjectsAndUpload";

const EditProfileContainer = () => {
  return(
    <>
    <Breadcrumbs pageTitle={EditProfile} parent={Users} title={EditProfile}/>
    <Container fluid>
        <div className="edit-profile">
          <Row>
            <MyProfile />
            <EditProfileForm/>
            <AddProjectsAndUpload />
          </Row>
        </div>
      </Container>
    </>
  )
};

export default EditProfileContainer;
